export enum ClientType {
    Personal = 1,
    JustInTime = 2,
    Business = 3
}
